export default "__VITE_ASSET__DPpq2ebq__"